import React, { useState, useRef } from "react";
import { MDBBtn, MDBInput } from "mdb-react-ui-kit";

const PasskeyDemo = () => {
  const [tokens, setTokens] = useState({ accessToken: "", idToken: "" });
  const tokenDisplayRef = useRef(null);
  const emailRef = useRef("");


  const client_id = "HqED8HKpQzl1XjmJAIGe397FyQN3El1i";
  const realm = "Username-Password-Authentication";
  const auth0Domain = "login.a0demo.com"; 

  const base64UrlToBase64 = (base64Url) =>
    base64Url.replace(/-/g, "+").replace(/_/g, "/") + "==".slice(0, (4 - base64Url.length % 4) % 4);

  const arrayBufferToBase64Url = (buffer) =>
    btoa(String.fromCharCode(...new Uint8Array(buffer)))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");

  const displayTokens = (tokens) => {
    setTokens({
      accessToken: tokens.access_token,
      idToken: tokens.id_token,
    });
    tokenDisplayRef.current.style.display = "block";
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const loginChallengeResponse = await fetch(
        `https://${auth0Domain}/passkey/challenge`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ client_id, realm }),
        }
      );

      if (!loginChallengeResponse.ok) throw new Error("Failed to request login challenge");

      const { authn_params_public_key, auth_session } = await loginChallengeResponse.json();
      const options = { ...authn_params_public_key };

      options.challenge = Uint8Array.from(
        atob(base64UrlToBase64(options.challenge)),
        (c) => c.charCodeAt(0)
      );

      if (options.allowCredentials) {
        options.allowCredentials = options.allowCredentials.map((cred) => ({
          ...cred,
          id: Uint8Array.from(atob(base64UrlToBase64(cred.id)), (c) => c.charCodeAt(0)),
        }));
      }

      const credential = await navigator.credentials.get({ publicKey: options });
      const credentialData = {
        id: credential.id,
        rawId: arrayBufferToBase64Url(credential.rawId),
        type: credential.type,
        response: {
          clientDataJSON: arrayBufferToBase64Url(credential.response.clientDataJSON),
          authenticatorData: arrayBufferToBase64Url(credential.response.authenticatorData),
          signature: arrayBufferToBase64Url(credential.response.signature),
        },
      };

      const authenticateResponse = await fetch(
        `https://${auth0Domain}/oauth/token`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            grant_type: "urn:okta:params:oauth:grant-type:webauthn",
            client_id,
            realm,
            auth_session,
            authn_response: credentialData,
          }),
        }
      );

      if (!authenticateResponse.ok) throw new Error("Failed to authenticate user");

      const tokens = await authenticateResponse.json();
      displayTokens(tokens);
      alert("User successfully logged in with Passkey!");
    } catch (error) {
      console.error("Error during login:", error.message);
      alert("An error occurred during login.");
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    const email = emailRef.current.value;

    try {
      const registerResponse = await fetch(
        `https://${auth0Domain}/passkey/register`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            client_id,
            realm,
            user_profile: { email, name: email },
          }),
        }
      );

      if (!registerResponse.ok) throw new Error("Failed to request signup challenge");

      const { authn_params_public_key, auth_session } = await registerResponse.json();
      const options = { ...authn_params_public_key };

      options.challenge = Uint8Array.from(
        atob(base64UrlToBase64(options.challenge)),
        (c) => c.charCodeAt(0)
      );

      options.user.id = Uint8Array.from(
        atob(base64UrlToBase64(options.user.id)),
        (c) => c.charCodeAt(0)
      );

      const credential = await navigator.credentials.create({ publicKey: options });

      const credentialData = {
        id: credential.id,
        rawId: arrayBufferToBase64Url(credential.rawId),
        type: credential.type,
        response: {
          clientDataJSON: arrayBufferToBase64Url(credential.response.clientDataJSON),
          attestationObject: arrayBufferToBase64Url(credential.response.attestationObject),
        },
      };

      const authenticateResponse = await fetch(
        `https://${auth0Domain}/oauth/token`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            grant_type: "urn:okta:params:oauth:grant-type:webauthn",
            client_id,
            realm,
            auth_session,
            authn_response: credentialData,
          }),
        }
      );

      if (!authenticateResponse.ok) throw new Error("Failed to authenticate new user");

      const tokens = await authenticateResponse.json();
      displayTokens(tokens);
      alert("Passkey registered and user authenticated successfully!");
    } catch (error) {
      console.error("Error during registration:", error.message);
      alert("An error occurred during registration.");
    }
  };

  return (
    <div className="container mt-5">
      <h1 className="text-center">Passkey API Register & Login Demo</h1>

      <div className="mt-4">
        <h2>Login</h2>
        <form onSubmit={handleLogin}>
          <MDBBtn type="submit" color="primary">
            Log In with Passkey
          </MDBBtn>
        </form>
      </div>

      <div className="mt-4">
        <h2>Register</h2>
        <form onSubmit={handleRegister}>
          <MDBInput
            type="email"
            inputRef={emailRef}
            label="Email"
            placeholder="Enter your email"
            required
            className="mb-3"
          />
          <MDBBtn type="submit" color="success">
            Sign Up with Passkey
          </MDBBtn>
        </form>
      </div>

      <div
        id="token-display"
        ref={tokenDisplayRef}
        className="border rounded p-3 mt-4 bg-light"
        style={{ display: "none" }}
      >
        <h2>Tokens</h2>
        <p>
          <strong>Access Token:</strong>
        </p>
        <pre>{tokens.accessToken}</pre>
        <p>
          <strong>ID Token:</strong>
        </p>
        <pre>{tokens.idToken}</pre>
      </div>
    </div>
  );
};

export default PasskeyDemo;
